<template>
  <div class="home wrapper">
    <div class="content">
      <Header></Header>
      <Breadcrumb
        :breadcrumbs="breadcrumbs"
      ></Breadcrumb>
      <Title :title="'Organograma'"></Title>

      <div class="container items-container">
        <div class="row">
          <div class="col-12 text-container">
            <p>
              O organograma da OAB Rondônia apresenta em forma de diagrama as relações hierárquicas e competências institucionais quanto ao seu Conselho Seccional, órgãos, comissões, Subseções e demais setores da entidade.
              A Seccional obedece ao Estatuto da Advocacia e da OAB, no Regulamento Geral, Regimento Interno e Código de Ética e Disciplina.
            </p>
          </div>
          <!-- /.col-12 -->

          <div class="col-12">
            <div class="organograma-container">
              <a :href="image" target="_blank">
                <div class="organograma-container-wrapper">
                  <div class="organograma-icon">
                    <i class="fa fa-sitemap" aria-hidden="true"></i>
                  </div>
                  <!-- /.organograma-icon -->

                  <div class="organograma-text">
                    Visualizar organograma
                  </div>
                  <!-- /.organograma-text -->
                </div>
                <!-- /.organograma-container-wrapper -->
              </a>
            </div>
            <!-- /.organograma-container -->
          </div>
          <!-- /.col-12 -->

        </div>
        <!-- /.row -->
      </div>
      <!-- /.container -->

    </div>
    <!-- /.content -->

    <Footer></Footer>
  </div>
  <!-- /.home wrapper -->
</template>

<script>
  import Header from '../../components/Header.vue';
  import Footer from '../../components/Footer.vue';
  import Breadcrumb from '../../components/Breadcrumb.vue';
  import Title from '../../components/generic/Title.vue';
  import Cards from '../../components/generic/Cards.vue';

  import OrganogramaImage from '../../assets/images/organograma/estrutura.jpg';

  export default {
    name: 'organograma',
    components: {
      Header,
      Footer,
      Breadcrumb,
      Title,
      Cards,
    },
    data () {
      return {
        image: OrganogramaImage,
        breadcrumbs: [
          {
            name: 'Início',
            link: '/'
          },
          {
            name: 'Gestão e Governança',
            link: '/gestaoegovernanca'
          },
          {
            name: 'Organograma',
          }
        ]
      }
    }
  };
</script>

<style lang="scss" scoped>
  .text-container {
    p {
      font-family: 'Lato', sans-serif;
      font-size: 19px;
      font-weight: 300;
      line-height: 1.4;
      text-align: center;
    }
  }

  a {
    text-decoration: none;
  }

  .organograma-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0 30px 0;
  }

  .organograma-container-wrapper {
    padding: 30px 20px;

    color: #ffffff;
    text-align: center;

    background-color: #bb3a31;
    border-radius: 5px;

    &:hover {
      background-color: #6d2722;
    }

    i {
      font-size: 50px;
    }
  }

  .organograma-text {
    font-family: 'Lato', sans-serif;
    font-weight: 300;
    font-size: 26px;
    line-height: 1.1;
  }
</style>
